import type { Dispatch, FunctionComponent, SetStateAction } from 'react'
import styled from 'styled-components'
import getRole from '../../utils/auth/roleTranslations'
import Modal from '../Modal/ModalElements/Modal'
import List, { ListVariant } from '../List/List'
import Paragraph from '../Paragraph/Paragraph'
import Heading from '../Heading/Heading'

const StyledModal = styled(Modal)`
  color: var(--dark);
  font-weight: 400;

  @media screen and (min-width: 48rem) {
    max-width: 75%;
  }
`

const StyledHeading = styled(Heading)`
  line-height: 1.6;
  display: flex;
  align-items: center;
  overflow: hidden;
  word-break: break-word;
  margin: 1.5rem 0 0.5rem;

  @media screen and (min-width: 48rem) {
    font-size: 1.5rem;
    line-height: 1.1;
  }
`

const StyledListItem = styled.li`
  margin-bottom: 0.5rem;
  p {
    margin: 0;
  }
  @media screen and (min-width: 48rem) {
    font-size: 1.125rem;
    line-height: 1.6;
    padding-left: 0.6rem;
    &::marker {
      font-size: 1.125rem;
    }
  }
`

const StyledRole = styled.p`
  margin: 0;
  color: var(--greyText);
  @media screen and (min-width: 48rem) {
    margin: 0 0 0 2.5rem;
  }
`

interface UserScopeModalProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<UserScopeModalProps['open']>>
  userName: string
  userGroups: string[]
  userScopes: string[]
}

const UserScopeModal: FunctionComponent<UserScopeModalProps> = ({
  open,
  setOpen,
  userName,
  userScopes,
  userGroups,
}) => (
  <StyledModal open={open} onClose={() => setOpen(false)} title={`Autorisaties van ${userName}`}>
    <Paragraph small>
      Hieronder zie je een overzicht van de onderdelen waar jouw account toegang tot heeft binnen
      data.amsterdam.nl.
      <br />
      <br />
      Moet jouw scope breder zijn dan de items die hieronder worden weergeven? Neem dan contact op
      met je leidinggevende.
    </Paragraph>
    <StyledHeading type="h4">Overzicht groepen</StyledHeading>
    <List variant={ListVariant.Bullet}>
      {userGroups.length > 0 &&
        userGroups.map((userGroup) => (
          <StyledListItem key={userGroup}>
            <Paragraph small>{userGroup.replace('/', '')}</Paragraph>
          </StyledListItem>
        ))}
    </List>
    <StyledHeading type="h4">Overzicht rollen</StyledHeading>
    <List variant={ListVariant.Bullet}>
      {userScopes.length > 0 &&
        userScopes.map((userScope) => (
          <StyledListItem key={userScope}>
            <Paragraph small>{userScope}</Paragraph>
            <StyledRole>{getRole(userScope)}</StyledRole>
          </StyledListItem>
        ))}
    </List>
  </StyledModal>
)

export default UserScopeModal
